export class UpdateAwsRestoreAccountAttributes {
    'roleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAwsRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
